<p-dialog header="Search or Request Authority" [closeOnEscape]="false" [(visible)]="display" [modal]="true"
  [closable]="false" class="request-authority-dialog" (onShow)="focusEntryLocation()" [focusOnShow]="false">
  <div class="request-authority-blocking" [hidden]="!blockDialog"><span>Loading...</span></div>
  <div class="request-authority-dispatcher-comment"
    [hidden]="dispatcherComment === null || dispatcherComment === undefined">
    <div class="dispatcher-comment">
      {{ dispatcherComment !== null && dispatcherComment !== undefined ? dispatcherComment.text : '' }}
    </div>
  </div>
  <div class="request-authority-content-wrapper inputStyle" *ngIf="!isDetailAuthority">
    <div class="request-authority-content-row">
      <div class="request-authority-content-column input-milepost">
        <label>Point of Entry:</label>
        <input #prefixMilepostInput name="prefixMilepostInput" type="text" [(ngModel)]="combinedPrefixMilepost"
          (blur)="validateAndGetAuthorityPointGroup($event)"
          [ngClass]="{ invalid: combinedPrefixMilepostValidationMessage !== null }" class="combined-prefix-milepost"
          required />
        <div *ngIf="combinedPrefixMilepostValidationMessage !== null">
          <p class="error-text">{{ combinedPrefixMilepostValidationMessage }}</p>
        </div>
      </div>
      <div class="request-authority-content-column input-until-dt">
        <label>Until Date &amp; Time:</label>
        <p-calendar name="calendarInput" mode="inline" [(ngModel)]="expirationDate"
          [inputStyleClass]="!validateTime() || timerValidationMessage !== null ? 'invalid' : ''" class="inline-block"
          [showIcon]="true" readonlyInput="readonlyInput" [minDate]="minDate" [keepInvalid]="true"
          [showOnFocus]="false"></p-calendar>
        <input class="input-time" type="number" (blur)="checkHour()" [(ngModel)]="expirationHour" min="1" max="23"
          [ngClass]="{ invalid: !validateTime() || timerValidationMessage !== null }" />
        <span>:</span>
        <input class="input-time" type="number" (blur)="checkMinutes()" [(ngModel)]="expirationMins" min="1" max="59"
          [ngClass]="{ invalid: !validateTime() || timerValidationMessage !== null }" />
        <div *ngIf="!validateTime() || timerValidationMessage !== null">
          <p class="error-text">{{ timerValidationMessage }}</p>
        </div>
      </div>
    </div>
    <div class="request-authority-content-row">
      <div class="request-authority-content-column input-range-label">
        <label class="request-authority-content-column">Range: {{ range }}</label>
      </div>
      <div class="request-authority-content-column input-range-slider">
        <p-slider name="sliderInput" class="request-authority-content-column"
          (onChange)="requestValidateAndGetAuthorityPointGroup($event)" [(ngModel)]="range" [max]="60" [min]="5"
          [step]="5"></p-slider>
      </div>
    </div>
    <hr />
    <br />
    <div class="authorities-available-list" *ngIf="isAuthoritiesAvailable">
      <available-authority [authorities]="authorities" (availableAuthorities)="showDetailAuthority($event)"
        (requestNew)="showRequestNewBox()"></available-authority>
    </div>
    <div class="request-new-box tabbing" *ngIf="isRequestNewSection">
      <div class="tabs">
        <button type="button" (click)="showAvailableAuthorities()" pButton
          label="{{ 'Authorities Found (' + authorities.length + ')' }}" class="p-button-outlined"></button>
        <button type="button" pButton label="New Request" class="active"></button>
      </div>

      <br />
      <div class="request-authority-content-row" *ngFor="let item of lineItemModelList; let i = index">
        <div class="lineItemHeader">
          <div class="request-authority-content-column line-item-count">
            Line 1{{ getLineNumberIdentifier(65 + i) }}
          </div>
          <div class="request-authority-content-column line-item-delete">
            <span [hidden]="lineItemModelList === undefined || lineItemModelList.length === 1">
              <button class="buttton-delete" (click)="deleteLineItem(item)">Delete</button>
            </span>
          </div>
        </div>
        <line-item [lineItemModel]="item" [authorityPointGroupList]="authorityPointGroupList"
          [chosenMilepost]="milepost" [chosenPrefix]="prefix" (block)="setBlock($event)"
          (outOfRangeViolation)="setOutOfRangeViolation($event)"></line-item>
      </div>
      <div [hidden]="shouldHideAdditionalLimits || lineItemModelList === undefined || lineItemModelList.length === 4"
        class="additional-limit">
        <a (click)="addLineItem()">+ Add Additional Limit</a>
      </div>
    </div>
  </div>
  <div class="detail-authority" *ngIf="isDetailAuthority">
    <detail-request-authority [authorityData]="authorityData"
      (availableAuthorities)="showAvailableAuthorities()"></detail-request-authority>
  </div>
  <p-footer>
    <div class="request-authority-content-wrapper request-authority-content-wrapper-footer">
      <div class="request-authority-content-row footer-row footer-comments"
        *ngIf="isRequestNewSection || isDetailAuthority">
        <div *ngIf="commentValidationError !== null && isRequestNewSection">
          <p class="error-text">{{ commentValidationError }}</p>
        </div>
        <label *ngIf="!isRequestNewSection">Reason / Comments <span class="optional-text">(Optional) </span></label>
        <label *ngIf="isRequestNewSection">Comments</label>
        <textarea rows="4" cols="56%" maxlength="250" [(ngModel)]="comment"
          (input)="validateCommentsForSpecialCharacters()" required
          [ngClass]="{ invalid: commentValidationError !== null && isRequestNewSection }"></textarea>
      </div>
      <div class="request-authority-content-row footer-row last-row content-action-group">
        <button type="button" pButton (click)="onCancel()" label="Cancel" class="p-button-outlined" [ngClass]="{
            'center-align-btn': !isRequestNewSection && !isDetailAuthority,
            'small-btn': isRequestNewSection || isDetailAuthority
          }"></button>
        <ng-template [ngIf]="isRequestNewSection || isDetailAuthority">
          <button type="button" pButton
            label="{{ isDetailAuthority ? 'Request to Share' : isRequestNewSection ? 'Submit Request' : '' }}"
            (click)="onSubmit()" class="submit-btn" [disabled]="hasOutOfRangeViolation"></button>
        </ng-template>
      </div>
    </div>
  </p-footer>
</p-dialog>